"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectModal = void 0;
var react_1 = __importStar(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
var ProviderSelect_1 = require("../components/ProviderSelect");
var constants_1 = require("../constants");
var screens_1 = require("../screens");
var use_contractkit_1 = require("../use-contractkit");
var styles_1 = require("./styles");
var ConnectModal = function (_a) {
    var reactModalProps = _a.reactModalProps, _b = _a.RenderProvider, RenderProvider = _b === void 0 ? ProviderSelect_1.ProviderSelect : _b, _c = _a.screens, screens = _c === void 0 ? screens_1.defaultScreens : _c;
    var connectionCallback = (0, use_contractkit_1.useContractKitInternal)().connectionCallback;
    var _d = __read((0, react_1.useState)(null), 2), adding = _d[0], setAdding = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), showMore = _e[0], setShowMore = _e[1];
    var close = (0, react_1.useCallback)(function () {
        setAdding(null);
        setShowMore(false);
        connectionCallback === null || connectionCallback === void 0 ? void 0 : connectionCallback(false);
    }, [connectionCallback]);
    var onSubmit = (0, react_1.useCallback)(function (connector) {
        setAdding(null);
        connectionCallback === null || connectionCallback === void 0 ? void 0 : connectionCallback(connector);
    }, [connectionCallback]);
    var onClickShowMore = (0, react_1.useCallback)(function () {
        setShowMore(true);
    }, []);
    var providers = (0, react_1.useMemo)(function () {
        return Object.entries(constants_1.PROVIDERS).filter(function (_a) {
            var _b = __read(_a, 2), provider = _b[1];
            return typeof window !== 'undefined' &&
                provider.showInList() &&
                Object.keys(screens).find(function (screen) { return screen === provider.name; });
        });
    }, [screens]);
    var prioritizedProviders = (0, react_1.useMemo)(function () { return providers.filter(function (_a) {
        var _b = __read(_a, 2), provider = _b[1];
        return provider.listPriority() === 0;
    }); }, [providers]);
    var modalContent;
    if (!adding) {
        var providersToDisplay = showMore ? providers : prioritizedProviders;
        modalContent = (react_1.default.createElement("div", { className: "tw-flex tw-flex-col tw-items-stretch" },
            react_1.default.createElement("h1", { className: "tw-pl-3 tw-pb-2 tw-text-lg tw-font-medium dark:tw-text-gray-300" }, "Connect a wallet"),
            providersToDisplay.map(function (_a) {
                var _b = __read(_a, 2), providerKey = _b[0], provider = _b[1];
                return (react_1.default.createElement(RenderProvider, { key: providerKey, provider: provider, onClick: function () { return setAdding(providerKey); } }));
            }),
            !showMore && (react_1.default.createElement("button", { onClick: onClickShowMore, className: "tw-font-medium tw-text-md tw-w-32 tw-self-center tw-mt-4 tw-text-blue-800 dark:tw-text-blue-400 hover:tw-text-blue-600 focus:tw-outline-none" }, "Show More"))));
    }
    else {
        var ProviderElement = screens === null || screens === void 0 ? void 0 : screens[adding];
        if (!ProviderElement) {
            return null;
        }
        modalContent = react_1.default.createElement(ProviderElement, { onSubmit: onSubmit });
    }
    return (react_1.default.createElement(react_modal_1.default, __assign({ isOpen: !!connectionCallback, onRequestClose: close, style: styles_1.defaultModalStyles, overlayClassName: "tw-fixed tw-bg-gray-100 dark:tw-bg-gray-700 tw-bg-opacity-75 tw-inset-0" }, reactModalProps, { ariaHideApp: false }),
        react_1.default.createElement("div", { className: "use-ck tw-bg-white dark:tw-bg-gray-800 tw-p-2" },
            react_1.default.createElement("div", { className: "tw-relative use-ck-connect-container" },
                react_1.default.createElement("button", { onClick: close, className: "tw-absolute tw-top-3 tw-right-2 tw-text-gray-700 dark:tw-text-gray-400 hover:tw-text-gray-800 dark:hover:tw-text-gray-300 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-p-1 tw-rounded" },
                    react_1.default.createElement("svg", { className: "tw-h-5 tw-w-5", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                        react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" })),
                    ' '),
                react_1.default.createElement("div", { className: "tw-px-4 tw-py-4" }, modalContent)))));
};
exports.ConnectModal = ConnectModal;
//# sourceMappingURL=connect.js.map